import React, { useState, useEffect } from "react";

import { isNaN } from "lodash";
import { useSelector } from "react-redux";
import WhiteSpaceServices from "../../../../services/WhiteSpace.services";
import { getModuleCode } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import RenderComponent from "../../../General/RenderComponent";
import ApexChart from "../../../Charts/ApexChart";
import { dynamicSort, formatNumber } from "../../../../utils/MainHelper";

function WhiteSpaceBarChartStacked({
    data, showZeroInChart, onChangeItemCount = () => { },
    clickBar = () => { }
}) {
    const [isNotYetLoaded, setIsNotYetLoaded] = useState(false);
    const [chartData, setChartData] = useState([]);
    const [deepdiveData, setDeepdiveData] = useState([]);
    const {
        generateGrid
    } = useSelector((state) => state.reports);

    const getDeepDiveData = () => {
        // const [itemName] = data.name.split(" (");
        // return generateGrid.find((d) => {
        //     if (d.name.includes(" > ")) {
        //         return itemName === d.name.split(" > ")[1];
        //     }
        //     return itemName === d.name;
        // });
        return generateGrid.find((d) => {
            return data.path === d.path;
        });
    };
    const deepdiveDetails = async () => {
        const cached = await WhiteSpaceServices.getDeepDiveData(data);
        setIsNotYetLoaded(!cached);
        setVisualData(cached);
    };

    const setVisualData = (foundData) => {
        setDeepdiveData(foundData);
        const visual = foundData.children.reduce((acc, d) => {
            acc.push({
                name: d.name,
                path: d.path,
                segmentSize: d.segmentSize,
                score: (d.diff < 0) ? 0 : d.diff,
                brandSpaceScore: d.brandSpace
            });
            return acc;
        }, []).sort(dynamicSort("brandSpaceScore", true));
        const moduleCode = getModuleCode();
        if (["healthcarewhitespaces", "veterinaryjourney"].includes(moduleCode)) {
            setChartData([...visual].slice(0, 20));
        } else {
            setChartData(visual);
        }
    };

    useEffect(() => {
        const foundData = getDeepDiveData();
        setIsNotYetLoaded(!foundData);
        if (foundData) {
            setVisualData(foundData);
        } else {
            deepdiveDetails();
        }
    }, [data]);

    const newData = showZeroInChart ? (chartData || []) : (chartData || []).filter((d) => d.score > 0);

    let height = "80mm";
    if (newData.length <= 2) {
        height = "50mm";
    } else if (newData.length > 3 && newData.length <= 7) {
        height = "130mm";
    } else if (newData.length >= 8 && newData.length < 15) {
        height = `${130 + ((newData.length / 2) * 8)}mm`;
    } else if (newData.length >= 15 && newData.length < 20) {
        height = `${130 + ((newData.length / 2) * 15)}mm`;
    } else if (newData.length >= 20) {
        height = `${130 + ((newData.length / 2) * 20)}mm`;
    }
    onChangeItemCount(newData?.length || 0);
    return (
        <div
            className="flex-1"
            style={{
                position: "relative",
                width: "100%",
                height,
                padding: "0 2mm"
            }}
        >
            <RenderComponent
                isFullscreen
                loadingProps={{
                    loading: isNotYetLoaded,
                    description: "Loading data..."
                }}
            >
                <ApexChart
                    style={{
                        width: "100%"
                    }}
                    options={{
                        chart: {
                            id: "orig-column",
                            toolbar: {
                                show: false
                            },
                            stacked: true,
                            animations: {
                                enabled: false
                            },
                            events: {
                                click(event, chartContext, config) {
                                    const name = config.config.xaxis.categories[config.dataPointIndex];
                                    const score = config.config.series[0].data[config.dataPointIndex];
                                    if (name) {
                                        let found = deepdiveData.children
                                            .find((d) => (`${d.name} (${formatNumber(d.segmentSize)})`) === name.join(" "));
                                        if (found) {
                                            found = {
                                                ...found,
                                                isDeepdive: true
                                            };
                                        }
                                        clickBar(name.join(" "), score, false, found);
                                    }
                                }
                            }
                        },
                        legend: {
                            show: false
                        },
                        colors: ["#263668"],
                        grid: {
                            show: false
                        },
                        xaxis: {
                            max: 140,
                            categories: newData.reduce((acc, d, idx) => {
                                if (!idx) {
                                    acc.push("-");
                                }
                                const cat = `${d.name} (${formatNumber(d.segmentSize)})`;
                                const catList = cat.split(" ");
                                if (catList.length === 1) {
                                    acc.push(cat);
                                } else {
                                    let tempText = "";
                                    acc.push(catList.reduce((acc2, c, index) => {
                                        if ((`${tempText}${c}`).length >= 25) {
                                            acc2.push(tempText.trim());
                                            tempText = `${c} `;
                                        } else {
                                            tempText += `${c} `;
                                        }
                                        if (index === catList.length - 1) { acc2.push(tempText.trim()); }
                                        return acc2;
                                    }, []));
                                }
                                return acc;
                            }, []),
                            labels: {
                                show: false
                            },
                            axisTicks: {
                                show: false
                            }
                        },
                        yaxis: {
                            labels: {
                                formatter: (val) => {
                                    if (isNaN(val) || val === "-") {
                                        return "";
                                    }
                                    return val;
                                },
                                align: "left",
                                minWidth: 200,
                                maxWidth: 200,
                                offsetX: 0,
                                offsetY: 11,
                                style: {
                                    fontSize: "12px"
                                }
                            }
                        },
                        stroke: {
                            show: true,
                            colors: ["#263668"],
                            width: 1
                        },
                        plotOptions: {
                            bar: {
                                horizontal: true,
                                dataLabels: {
                                    orientation: "horizontal",
                                    position: "bottom"
                                }
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            formatter: (val) => (!isNaN(val) && val !== null ? `${val}%` : ""),
                            style: {
                                fontSize: "12px",
                                colors: ["white"],
                                fontWeight: "normal"
                            },
                            offsetX: 20,
                            offsetY: 0,
                            background: {
                                enabled: true,
                                foreColor: "black",
                                padding: 4,
                                borderRadius: 0,
                                borderWidth: 1,
                                opacity: 0.9
                            }
                        },
                        annotations: {
                            position: "front",
                            xaxis: [{
                                x: 100,
                                x2: null,
                                offsetX: 0,
                                offsetY: 10,
                                strokeDashArray: 2,
                                borderWidth: 2,
                                borderColor: "gray",
                                fillColor: "transparent",
                                opacity: 0.3
                            }],
                            points: [{
                                x: 0,
                                yAxisIndex: 0,
                                seriesIndex: 0,
                                marker: {
                                    size: 0
                                },
                                label: {
                                    borderColor: "#263668",
                                    borderWidth: 2,
                                    borderRadius: 0,
                                    text: "Brand Space",
                                    textAnchor: "middle",
                                    offsetX: 48,
                                    offsetY: -15,
                                    style: {
                                        background: "#263668",
                                        color: "white",
                                        fontSize: "12px",
                                        padding: {
                                            left: 10,
                                            right: 10,
                                            top: 5,
                                            bottom: 5
                                        }
                                    }
                                }
                            }, {
                                x: 100,
                                seriesIndex: 0,
                                marker: {
                                    size: 0
                                },
                                label: {
                                    offsetX: -40,
                                    offsetY: -55,
                                    borderColor: "#799FC6",
                                    borderWidth: 2,
                                    borderRadius: 0,
                                    text: "Market Gap",
                                    textAnchor: "middle",
                                    style: {
                                        background: "#799FC6",
                                        color: "white",
                                        fontSize: "12px",
                                        padding: {
                                            left: 10,
                                            right: 10,
                                            top: 5,
                                            bottom: 5
                                        }
                                    }
                                }
                            }]
                        },
                        fill: {
                            colors: ["#263668", "#799FC6"],
                            type: "solid"
                        }
                    }}
                    series={["Brand Space", "Market Gaps"].map((name) => {
                        if (name === "Brand Space") {
                            return {
                                name,
                                data: newData.reduce((acc, d, idx) => {
                                    if (!idx) {
                                        acc.push(null);
                                    }
                                    acc.push((d.brandSpaceScore).toFixed(2));
                                    return acc;
                                }, [])
                            };
                        }
                        return {
                            name,
                            data: newData.reduce((acc, d, idx) => {
                                if (!idx) {
                                    acc.push(null);
                                }
                                acc.push((d.score).toFixed(2));
                                return acc;
                            }, [])
                        };
                    })}
                />
            </RenderComponent>
        </div>
    );
}

export default WhiteSpaceBarChartStacked;
